// extracted by css-extract-rspack-plugin
export default {"wrapper":"_262d430","photoWrapper":"_5b3bf33c"};